import React from 'react';
import {withRouter} from 'react-router-dom'
import {selectCartHidden} from '../../redux/cart/cart.selectors'
import TemporaryDrawer from '../cart-dropdown/cart-dropdown.component'
import {createStructuredSelector} from 'reselect'
import { selectDirectorySections } from "../../redux/directory/directory.selectors";
import './header.styles.scss'
import {selectCartItemsCount} from '../../redux/cart/cart.selectors'
import { Link } from "react-router-dom";
import {selectCurrentUser} from '../../redux/user/user.selectors'
import {connect} from 'react-redux';
import './header.styles'
import {signOutStart} from '../../redux/user/user.actions'
import Logo from '../../assets/logo.png'

const Header = ({currentUser,signOutStart}) => {

  const burger = () => {
    const navLinks = document.querySelector('.nav-links');
    const burger = document.querySelector('.hamburger-menu');
    // const navbar = document.querySelector('.navbar');
    navLinks.classList.toggle('nav-active');
    burger.classList.toggle('bar-change');
  }

// Sticky navbar
  // window.addEventListener('scroll', () => {
  //     navbar.classList.toggle('sticky', scrollY > 0)
  // })
  return (
    <header class="header">
    <nav class="navbar">
        <Link to="/"><h1 class="logo"><img src={Logo} alt=""/></h1></Link>
        <ul class="nav-links">
        <a href="/"><Link to="/"><li onClick={burger}>Home</li></Link></a>
           <Link to="/shop"><li onClick={burger}><a href="/shop">Shop</a></li></Link>
           {/* <a href="/categories"><Link to="/categories" onClick={burger}><li>Categories</li></Link> </a> */}
           {
              currentUser ? 
              <a href="/"><Link onClick={signOutStart}><li onClick={burger}>Log Out</li></Link></a>

            :
            <a href="/signin"><Link to="/signin"><li onClick={burger}>Log In</li></Link></a>
            }
        </ul>
        <div style={{display:"flex",alignContent:"center"}}>
        <TemporaryDrawer/>
        <div onClick={burger} class="hamburger-menu">
            <div class="bar1"></div>
            <div class="bar2"></div>
            <div class="bar3"></div>
        </div>
        </div>
    </nav>
    {/* <div class="showcase">
        <h1>Stay Healthy and Safe</h1>
        <button>See More</button>
    </div> */}
  </header>

  );
}
const mapStateToProps = createStructuredSelector({
    currentUser:selectCurrentUser,
    sections: selectDirectorySections,
    itemCount : selectCartItemsCount,
    hidden: selectCartHidden,
})
const mapDispatchToProps = dispatch => ({
    signOutStart : () => dispatch(signOutStart()),
})
export default withRouter(connect(mapStateToProps,mapDispatchToProps)(Header))